import { FieldType, Schema } from "../../../../toolympus/hooks/useSchema";
import { TreeItemsConfigWithManage, useManageTree } from "../../../../toolympus/components/Trees";

export interface Topic {
  _id: number;
  title: string;
  parent_id?: string | null;
  sort_order: number;
  created_by?: string;
  created_at?: string;
}

export const TopicSchema: Schema = {
  _id: { label: "ID", type: FieldType.number },
  sort_order: { label: "Sort order", type: FieldType.number },
  title: { label: "Title" },
  parent_id: { label: "Parent" },
  country: { label: "State", dictionary: "Countries", type: FieldType.dictionarySelect },
  created_by: { label: "Created by", dictionary: "Users", type: FieldType.dictionarySelect },
  created_at: { label: "Created at", type: FieldType.datetime },
}

const ApiPath = "/api/settings/topic";


export const TopicTreeConfig: TreeItemsConfigWithManage<Topic> = {
  idField: "_id",
  parentIdField: "parent_id",
  newItemDefault: { title: "" },
  sortField: "sort_order",
  textFilterBy: t => t.title,
  itemTitle: t => t.title,
}

export const useManageTopics = () => {
  const data = useManageTree<Topic>(TopicTreeConfig, ApiPath);

  return {
    ...data, 
  }
}
